import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CarClickType, ReportType } from "types/loadedData";

interface ReportState {
  reports: ReportType[];
  clicks: CarClickType[];
}

const initialState: ReportState = {
  reports: [],
  clicks: [],
};

export const car = createSlice({
  name: "car",
  initialState,
  reducers: {
    setReports: (state, action: PayloadAction<ReportType[]>) => {
      state.reports = action.payload;
    },
    setClicks: (state, action: PayloadAction<CarClickType[]>) => {
      state.clicks = action.payload;
    },
  },
});

export const { setClicks, setReports } = car.actions;

export default car.reducer;
